import styles from './ScanToUploadFile.module.css';

function PDFViewer({ images }: { images: string[] }) {
  return (
    <div className={styles.pdfPreview}>
      {images.map((img, idx) => {
        // Logic to prevent double-prefixing
        const imageSrc = img.startsWith('data:') 
          ? img 
          : `data:image/jpeg;base64,${img}`;

        return (
          <div key={idx} className={styles.pdfPageWrapper}>
            <span className={styles.pageNumber}>Page {idx + 1}</span>
            <img
              src={imageSrc}
              alt={`Page ${idx + 1}`}
              className={styles.pdfPagePreview}
              // Adding an error handler helps debug if strings are corrupt
              onError={(e) => {
                console.error(`Image at index ${idx} failed to load`);
                (e.target as HTMLImageElement).src = "/placeholder-error.png";
              }}
            />
          </div>
        );
      })}
      
      {images.length === 0 && (
        <div className={styles.noPages}>No images captured yet.</div>
      )}
    </div>
  );
}

export default PDFViewer;